var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"rossetto-button",class:("rossetto-button--" + _vm.type),attrs:{"href":_vm.url,"target":_vm.buttonTarget}},[_c(_vm.buttonType,{tag:"component"}),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }